/*
 * File: monitoring.service.ts
 * Project: rast-app
 * Create Date: Wednesday, 1st April 2026
 * Author: Pedro Santos (pedro.santos@vonbraunlabs.com)
 * -----
 * Last Modified: Wednesday, 1st April 2026
 * Modified by: Pedro Santos (pedro.santos@vonbraunlabs.com)
 * -----
 * Copyright (c) 2026 CPA Wernher von Braun
 * ----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	---------------------------------------------------------
 */

import { Injectable } from '@angular/core';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';

@Injectable({
  providedIn: 'root'
})
export class MonitoringService {

  async log(message: string) {
    await FirebaseCrashlytics.log({ message });
  }

  async recordError(error: any) {
    await FirebaseCrashlytics.recordException({
      message: error?.message || 'Erro desconhecido'
    });
  }

  async crashTest() {
    throw new Error('Crash de teste');
  }
}
